import React, { useState } from 'react';
import Modal from 'sharedWebpack/Modal';
import PropTypes from 'prop-types';
import Input from '@wtag/rcl-input';
import Alert from 'sharedWebpack/Alert';
import Button from '@wtag/rcl-button';
import Icon from '@wtag/rcl-icon';
import httpClient from 'agentHTTPClient';
import routes from 'agentRoutes';

const TravelerLoginModal = ({ modalOpen, setModalOpen }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const logInUser = async () => {
    const logInParams = {
      email,
      password,
    };

    const { data } = await httpClient.post(routes.public.authentication.sessions.create(), {
      session: logInParams,
    });

    if (data.errors === null) window.location.reload();
  };

  const submitForm = () => {
    logInUser().catch(({ response }) => {
      setError('');
      if (response.status === 422) {
        setError(response.data.errors);
      }
    });
  };

  const closeError = () => setError('');

  const modalTitleContent = (
    <div className="top-nav__account-switch-modal-title">
      <div>{I18n.t('public.session.log_in')}</div>
      <div
        onClick={() => setModalOpen(false)}
        onKeyDown={() => setModalOpen(false)}
        role="presentation"
      >
        <Icon name="close" />
      </div>
    </div>
  );

  return (
    <div>
      <Modal
        className="authentication-form__modal"
        title={modalTitleContent}
        isModalVisible={modalOpen}
        onOutsideClick={() => setModalOpen(false)}
      >
        <div className="grid col-12 col-bleed">
          <div className="col-12 col-bleed">
            <Alert
              className="authentication-form__alert"
              hideClose={false}
              isVisible={!!error}
              onClose={closeError}
              type="danger"
            >
              {error}
            </Alert>
            <div className="col-12 col-bleed authentication-form__field--with-bottom-padding">
              <Input
                required={true}
                type="email"
                size="small"
                placeholder={I18n.t('public.components.authentication.sessions.placeholders.email')}
                label={I18n.t('public.components.authentication.sessions.labels.email')}
                onChange={value => setEmail(value)}
                value={email}
              />
            </div>
            <div className="col-12 col-bleed authentication-form__field--with-bottom-padding">
              <Input
                required={true}
                type="password"
                size="small"
                placeholder={I18n.t(
                  'public.components.authentication.sessions.placeholders.password',
                )}
                label={I18n.t('public.components.authentication.sessions.labels.password')}
                onChange={value => setPassword(value)}
                value={password}
              />
            </div>
            <div className="col-12 col-bleed col-grid direction-row authentication-form__button--with-top-padding">
              <Button
                version="v2"
                size="normal"
                primary={true}
                label={I18n.t('public.session.log_in')}
                onClick={submitForm}
                fullWidth={true}
              />
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

TravelerLoginModal.propTypes = {
  modalOpen: PropTypes.bool.isRequired,
  setModalOpen: PropTypes.func.isRequired,
};

export default TravelerLoginModal;
